"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fileSaver = require("file-saver");
var _decoration = require("@/api/decoration");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationDocument',
  data: function data() {
    return {
      loading: false,
      downloadingId: null,
      drawerVisible: false,
      detail: null,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        documentType: '',
        status: '',
        overdue: false
      },
      tableData: {
        data: [],
        total: 0
      },
      typeOptions: [{
        value: 'confirmation',
        label: '工地确认单'
      }, {
        value: 'delay',
        label: '工期延期单'
      }, {
        value: 'change',
        label: '项目变更单'
      }, {
        value: 'rectification',
        label: '施工整改单'
      }, {
        value: 'acceptance',
        label: '工程验收单'
      }],
      statusOptions: [{
        value: 'draft',
        label: '草稿'
      }, {
        value: 'pending_approval',
        label: '待审批'
      }, {
        value: 'pending_sign',
        label: '待双方签字'
      }, {
        value: 'pending_rectification',
        label: '待整改'
      }, {
        value: 'pending_confirm',
        label: '待确认 / 复检 / 验收'
      }, {
        value: 'completed',
        label: '已闭环'
      }, {
        value: 'rejected',
        label: '已驳回'
      }, {
        value: 'cancelled',
        label: '已取消'
      }],
      typeText: {
        confirmation: '工地确认单',
        delay: '工期延期单',
        change: '项目变更单',
        rectification: '施工整改单',
        acceptance: '工程验收单'
      },
      typeTag: {
        confirmation: 'info',
        delay: 'warning',
        change: 'primary',
        rectification: 'danger',
        acceptance: 'success'
      },
      statusTag: {
        draft: 'info',
        pending_approval: 'warning',
        pending_sign: 'warning',
        pending_rectification: 'danger',
        pending_confirm: 'warning',
        completed: 'success',
        rejected: 'danger',
        cancelled: 'info'
      }
    };
  },
  computed: {
    pendingCount: function pendingCount() {
      return this.tableData.data.filter(function (item) {
        return ['pending_approval', 'pending_sign', 'pending_rectification', 'pending_confirm'].includes(item.document.status);
      }).length;
    },
    completedCount: function completedCount() {
      return this.tableData.data.filter(function (item) {
        return item.document.status === 'completed';
      }).length;
    },
    overdueCount: function overdueCount() {
      return this.tableData.data.filter(function (item) {
        return item.document.overdue;
      }).length;
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    statusText: function statusText(value) {
      return (this.statusOptions.find(function (item) {
        return item.value === value;
      }) || {}).label || value;
    },
    money: function money(value) {
      var number = Number(value || 0);
      return "".concat(number > 0 ? '+' : '', "\xA5").concat(number.toFixed(2));
    },
    days: function days(value) {
      var number = Number(value || 0);
      return "".concat(number > 0 ? '+' : '').concat(number, " \u5929");
    },
    acceptanceType: function acceptanceType(value) {
      return value === 'final_acceptance' ? '竣工验收' : '阶段验收';
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationDocumentListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        documentType: '',
        status: '',
        overdue: false
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openDetail: function openDetail(row) {
      this.detail = row;
      this.drawerVisible = true;
    },
    downloadPdf: function () {
      var _downloadPdf = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var response, type, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.downloadingId = row.document.id;
              _context.p = 1;
              _context.n = 2;
              return (0, _decoration.decorationDocumentPdfApi)(row.document.id);
            case 2:
              response = _context.v;
              type = response.headers['content-type'] || '';
              if (type.includes('application/pdf')) {
                _context.n = 3;
                break;
              }
              throw new Error('PDF 响应格式不正确');
            case 3:
              (0, _fileSaver.saveAs)(new Blob([response.data], {
                type: 'application/pdf'
              }), "".concat(row.document.documentNo, ".pdf"));
              this.$message.success('PDF 单据已下载');
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error(_t.message || 'PDF 下载失败');
            case 5:
              _context.p = 5;
              this.downloadingId = null;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function downloadPdf(_x) {
        return _downloadPdf.apply(this, arguments);
      }
      return downloadPdf;
    }()
  }
};